import React, { lazy } from 'react'
import { FrontUrls } from 'Constants/FrontUrls'
import { Switch } from 'react-router-dom'
import { useAppDispatch, useEffectOnce } from 'Src/hooks'
import { filtersSlice, LazyRoute, PAGE_SLUG } from 'Modules'
import { userSelector, userSlice } from 'Pages/user'
import { useSelector } from 'react-redux'

const UserListLazy = lazy(() => import('Pages/user/components/mobile/UserList/List/index'))
const UserFilterLazy = lazy(() => import('Pages/user/components/mobile/UserList/Filter/index'))
const UserInfoLazy = lazy(() => import('Pages/user/components/mobile/UserList/Info/index'))
const OptionInfoComponent = lazy(
	() => import('Pages/user/components/mobile/UserList/Info/OptionInfo/index')
)
const ConsentComponent = lazy(
	() => import('Pages/user/components/mobile/UserList/Info/tabs/Account/UserConsent/index')
)
const UserCreate = lazy(() => import('Pages/user/components/mobile/UserCreate/index'))

const actions = {
	clearFilters: filtersSlice.actions.clearFilters,
	getAll: userSlice.actions.getAll,
	clearAll: userSlice.actions.clearAll,
}

export const MobileUserRoutes = () => {
	const { clearFilters, getAll, clearAll } = useAppDispatch(actions)

	const params = useSelector(userSelector.selectCurrentParams)

	useEffectOnce(() => {
		getAll({ params, clear: true })
		return () => {
			clearFilters(PAGE_SLUG.USER)
			clearAll()
		}
	})

	return (
		<Switch>
			<LazyRoute
				exact
				path={FrontUrls.mobile_user.consent}
				lazyComponent={ConsentComponent}
				key={FrontUrls.mobile_user.consent}
			/>
			<LazyRoute
				exact
				path={FrontUrls.mobile_user.edit}
				lazyComponent={UserCreate}
				key={FrontUrls.mobile_user.edit}
			/>
			<LazyRoute
				exact
				path={FrontUrls.mobile_user.info}
				lazyComponent={UserInfoLazy}
				key={FrontUrls.mobile_user.info}
			/>
			<LazyRoute
				exact
				path={FrontUrls.mobile_user.filter}
				lazyComponent={UserFilterLazy}
				key={FrontUrls.mobile_user.filter}
			/>
			<LazyRoute
				exact
				path={FrontUrls.mobile_user.index}
				lazyComponent={UserListLazy}
				key={FrontUrls.mobile_user.index}
			/>
			<LazyRoute
				exact
				path={FrontUrls.mobile_user.option}
				lazyComponent={OptionInfoComponent}
				key={FrontUrls.mobile_user.option}
			/>
		</Switch>
	)
}
